import React from "react";

export const MiningSection = () => {
  return (
    <div className=" bg-[#05994F14] py-20">
      <div className="max-w-7xl mx-auto text-center ">
        <p className="text-[#05994F] font-roboto-condensed font-[500] text-[19px] leading-[15.84px] mb-4">
          Mining Pakistan's engine of progress
        </p>
        <div className="font-roboto-condensed font-[500] text-[64px] leading-[76.11px] mb-4">
          Welcome to Pakistan Minerals Information and Services Portal
        </div>
        <div className="text-center font-roboto-condensed font-[400] text-[20.59px] leading-[22.97px]">
          A gateway for economic prosperity. Showcasing Pakistans mineral and
          mining sector to the world.
        </div>
      </div>
    </div>
  );
};
